module.exports = __webpack_public_path__ + "img/logo-zl1.3a0275ea.png";